import { useMutation } from '@apollo/client';
import { get } from 'lodash';

import PROJECT_USER_CREATE_IN_BULK from '../graphql/projectUserCreateInBulk.graphql';
import GET_PROJECT_USERS from '../graphql/GetProjectUsers.graphql';
import { PROJECT_USERS_PER_PAGE, ORDER_BY_NAME } from '../constants';

const useProjectUserCreate = ({ onCompleted, onError, projectId }) => {
  const [createProjectUsers, { loading, error }] = useMutation(
    PROJECT_USER_CREATE_IN_BULK,
    {
      refetchQueries: [
        {
          query: GET_PROJECT_USERS,
          variables: {
            projectId,
            first: PROJECT_USERS_PER_PAGE,
            after: null,
            orderBy: ORDER_BY_NAME,
          },
        },
      ],
      onCompleted: (data) => {
        const errors = get(data, 'projectUserCreateInBulk.errors', []) || [];

        if (errors.length) {
          onError?.(error);
        } else {
          onCompleted?.(data);
        }
      },
      onError: () => {
        onError?.(error);
      },
    },
  );

  return { createProjectUsers, loading };
};

export default useProjectUserCreate;
